import {GeneralConstant} from '../constants/GeneralConstant';

export function checkForPermission(p: string) {
  if (!p) {
    return;
  }
  const perms = JSON.parse(localStorage.getItem(GeneralConstant.PERMISSIONS));

  if (!perms) {
    return;
  }

  const permissions = p.split(',');
  const usersPermissions = perms.filter(permission => permission.access)
    .map(perm => `${perm.application.toLowerCase()}.${perm.module.toLowerCase()}.${perm.action.toLowerCase()}`);

  return permissions.some(permission => usersPermissions.includes(permission.toLowerCase()));
}

export function checkForPermissionWithFacility(p: string, facilityId: number) {
  if (!p) {
    return;
  }
  const perms = JSON.parse(localStorage.getItem(GeneralConstant.PERMISSIONS));

  if (!perms) {
    return;
  }

  const permissions = p.split(',');
  const usersPermissions = perms.filter(permission => permission.access && (permission.facilities.length > 0 && permission.facilities.includes(facilityId)))
    .map(perm => `${perm.application.toLowerCase()}.${perm.module.toLowerCase()}.${perm.action.toLowerCase()}`);

  return permissions.some(permission => usersPermissions.includes(permission.toLowerCase()));
}

export function checkForPermissionWithExceptions(p: string, groups: string[], exceptions: string[]) {
  if (!p) {
    return;
  }
  const perms = JSON.parse(localStorage.getItem(GeneralConstant.PERMISSIONS));

  if (!perms) {
    return;
  }

  const permissions = p.split(',');
  const usersPermissions = perms.filter(permission => permission.access)
    .map(perm => `${perm.application.toLowerCase()}.${perm.module.toLowerCase()}.${perm.action.toLowerCase()}`);
  return permissions.some(permission => usersPermissions.includes(permission.toLowerCase())) && !groups.some(it => (exceptions || []).includes(it));
}

